import * as notify from "../../../../../shared/notify";

const nutrientValidation = (nutrients) => {
    let nutrientsValid = true;
    nutrients.forEach((item) => {
        if (!item.name.text) {
            nutrientsValid = false;
        }
    });

    return nutrientsValid;
};

const ingredientValidation = (panels) => {
    let sectionValid = true;
    panels.forEach((panel) => {
        if (!nutrientValidation(panel.activeIngredients)) {
            sectionValid = false;
        }
    });

    return sectionValid;
};

const warningValidation = (panels) => {
    let sectionValid = true;

    panels.forEach((panel) => {
        if (panel.warnings) {
            panel.warnings.forEach((warning) => {
                if (!warning.text) {
                    sectionValid = false;
                }
            });
        }
    });

    return sectionValid;
};

const usesValidation = (panels) => {
    let sectionValid = true;

    panels.forEach((panel) => {
        if (panel.uses) {
            panel.uses.forEach((use) => {
                if (!use.text) {
                    sectionValid = false;
                }
            });
        }
    });

    return sectionValid;
};

export const validatePanel = (panels) => {
    let isValid = true;

    if (!ingredientValidation(panels)) {
        notify.error("Active Ingredient can not be blank");
        isValid = false;
    }

    if (!warningValidation(panels)) {
        notify.error("Warning can not be blank");
        isValid = false;
    }

    if (!usesValidation(panels)) {
        notify.error("Uses can not be blank");
        isValid = false;
    }

    return isValid;
};
